__turbopack_context__.v({
  "content": "FavoriteChip-module-scss-module__k69W7W__content",
  "count": "FavoriteChip-module-scss-module__k69W7W__count",
  "dark-gray-text": "FavoriteChip-module-scss-module__k69W7W__dark-gray-text",
  "disabled": "FavoriteChip-module-scss-module__k69W7W__disabled",
  "fav-wrapper": "FavoriteChip-module-scss-module__k69W7W__fav-wrapper",
  "icon": "FavoriteChip-module-scss-module__k69W7W__icon",
  "outlined": "FavoriteChip-module-scss-module__k69W7W__outlined",
  "text": "FavoriteChip-module-scss-module__k69W7W__text",
  "with-bg": "FavoriteChip-module-scss-module__k69W7W__with-bg",
  "with-border": "FavoriteChip-module-scss-module__k69W7W__with-border",
  "with-text": "FavoriteChip-module-scss-module__k69W7W__with-text",
  "without-text": "FavoriteChip-module-scss-module__k69W7W__without-text",
});
